export enum RulesEvents {
	CHANGE_RULE_FLOW = 'changeRuleFlow',
	UPDATE_STATUS = 'onUpdateStatus',
    NEW_RULE = 'onCreateNewRule',
	NEW_COMMENT = 'onCreateComment',
	NEW_STIP = 'onCreateStip',
	DELETE_COMMENT = 'onDeleteComment',
	DELETE_STIP = 'onDeleteStip'
}